export enum AssetTransmission {
    AUTOMATIC = 'AUTOMATIC',
    MANUAL = 'MANUAL',
}
